import styles from './style.module.css';

type Opacity = 'normal' | 'darker';
export const opacityToClassName = (opacity: Opacity) => {
  let className: string | undefined;
  switch (opacity) {
    case 'normal':
      className = styles.normalOverlay;
      break;
    case 'darker':
      className = styles.darkerOverlay;
      break;
  }
  return className;
};
